/**
 * 校验手机号码格式
 */
export var isMobile = function (mobile) { return /^1[2-9]\d{9}$/.test(mobile); };
/**
 * 1.1以后改为字母+数字，长度8-16位
 */
export var checkPassword = function (password) { return /^(?=.*[a-zA-Z])(?=.*\d)[\w\W]{8,16}$/.test(password); };
export var checkCode = function (code) { return /^\d{6}$/.test(code); };
// 整数或者小数
export var FLOAT_REG = /^\d+(\.\d{1,2})?$/;
